import { render, staticRenderFns } from "./ModalRepassesCarregados.vue?vue&type=template&id=088236e1&scoped=true"
import script from "./ModalRepassesCarregados.vue?vue&type=script&lang=ts"
export * from "./ModalRepassesCarregados.vue?vue&type=script&lang=ts"
import style0 from "./ModalRepassesCarregados.vue?vue&type=style&index=0&id=088236e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088236e1",
  null
  
)

export default component.exports